import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay,
    AlertDialogPortal,
    AlertDialogTitle,
    AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export default function TCSWarning({
    children,
    handleSubmit,
    order_id,
    tcsValue,
    tcs_amount,
}: {
    children: React.ReactNode;
    handleSubmit: () => void;
    order_id: string;
    tcsValue: string;
    tcs_amount: number;
}) {
    return (
        <AlertDialog>
            <AlertDialogTrigger>{children}</AlertDialogTrigger>
            <AlertDialogPortal>
                <AlertDialogOverlay className=" bg-black-900 bg-opacity-60 animate-overlayShow fixed inset-0" />
                <AlertDialogContent className="bg-white-A700 rounded-lg p-0 max-w-2xl animate-contentShow">
                    <AlertDialogHeader className="flex text-left gap-4 pt-8 pb-4 px-10 ">
                        <AlertDialogTitle className="font-bold text-xl text-red-500 leading-7 tracking-[2%]">
                            Warning
                        </AlertDialogTitle>
                        <AlertDialogDescription className="font-medium text-base -tracking-[3%] text-black-900 leading-[150%]  ">
                            TCS of Rs {tcs_amount} was calculated by the system which is
                            greater than {tcsValue}
                            <p className="pt-6">Do you still want to continue?</p>
                        </AlertDialogDescription>
                    </AlertDialogHeader>
                    <AlertDialogFooter className="flex justify-end items-center gap-2.5 py-5 px-10 flex-row rounded-b-lg bg-gray-button-gray-lite">
                        <AlertDialogCancel className=" m-0 rounded-lg border-blue-700 border py-[11px] px-4 text-blue-700">
                            Cancel
                        </AlertDialogCancel>
                        <AlertDialogAction
                            className="rounded-lg border-blue-700 py-[11px] px-4 bg-blue-700 border text-white-A700"
                            onClick={handleSubmit}
                        >
                            Continue
                        </AlertDialogAction>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogPortal>
        </AlertDialog>
    );
};
